import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-danger text-center",
  "data-test": "scratchpad-subject-error"
}
const _hoisted_2 = {
  key: 1,
  class: "text-danger text-center",
  "data-test": "scratchpad-save-error"
}
const _hoisted_3 = { class: "col-sm-9 col-padding" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "page-title" }, null, -1)
const _hoisted_6 = {
  class: "scratchpad-paper-user",
  style: {"position":"relative"}
}
const _hoisted_7 = { class: "textarea-backing" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "$vars", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("small", { style: {"color":"#aaa"} }, "ctrl + enter  ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-play" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  class: "journal-paper-user scratchpad-transcript",
  "data-test": "smart-scratchpad-output-container"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["data-test"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "scratchpad-assistant" }, "Assistant:", -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "scratchpad-directive" }, "@Assistant", -1)
const _hoisted_26 = { class: "scratchpad-response" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("small", { style: {"color":"#aaa"} }, "option + enter  ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-ok" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "col-sm-3" }
const _hoisted_31 = {
  key: 0,
  class: "loading-text"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "variable"
}

import {
  DataSubject,
  DataSubjects,
  getDataContextWithSubject,
  getTypeFromParam,
} from "./subject-type";

import chat from "./chat";
import {
  syntaxToApiCall,
  applyVars,
  getDataContext,
  getVarList,
  parse,
  SyntaxFragment,
  getVar,
} from "./process-prompt-vars";
import { AxiosError } from "axios";
import { csContext } from "../../services/cs-context";
import saveEntry from "./scratchpad-history";
import { ScratchpadEntryApiModel } from "../../api-models";
import { debug as d } from "debug";
import { ref, watch, computed, onMounted, nextTick, CSSProperties } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'smart-scratchpad',
  props: {
    currentChat: {}
  },
  emits: ["update-history-item"],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable */
const debug = d("cs.ScratchPad");

const props = __props;

const emit = __emit;

// template refs
const textareaRef = ref<HTMLTextAreaElement | null>(null);

const text = ref((window["_jyreScratchpadText"] as string) || "");
const cached = ref({ text: "", syntax: [] as SyntaxFragment[] });
const transcriptButtonHasBeenClicked = ref(false);

const response = ref("");
const subjectError = ref<null | string>(null);
const saveError = ref<null | string>(null);
const inputTimeout = ref<null | number>(null);
const dataContext = ref<ReturnType<typeof getDataContext> | null>(null);
const varList = ref([] as { path: string; data: string }[]);
const isMounted = ref(false);
const ctx = csContext;

const title = ref(props.currentChat?.pageTitle ?? "Untitled");

const showTranscript = computed(() => {
  return (
    transcriptButtonHasBeenClicked.value &&
    syntax.value &&
    syntax.value[0] &&
    (syntax.value[0].output || syntax.value[0].error)
  );
});

function truncateData(data: string) {
  data = data || "";
  if (filteredSideList.value.length === 1) {
    return data;
  }
  let newData = data.split("\n").slice(0, 3).join("\n").slice(0, 100);
  if (newData.length !== data.length && newData.trim()) {
    newData = newData + "...";
  }
  return newData;
}

function getGhostText(synt: SyntaxFragment) {
  if (synt.directive?.name !== "Assistant") {
    return undefined;
  }

  if (synt.directive.options.trim()) {
    return "";
  }

  let whichAssistantCall = syntax.value
    .filter((x) => x.directive?.name === "Assistant")
    .findIndex((x) => x === synt);

  let prefix = "                         ";
  let text = assistantGhostTexts.value[whichAssistantCall];
  if (text !== undefined && !assistantGhostTextsAreCompleted.value[whichAssistantCall]) {
    prefix = prefix + "🖊️";
  }
  return prefix + (text ?? "".trim());
}

function trailingLines(synt: SyntaxFragment) {
  let nextFragment = syntax.value[syntax.value.findIndex((s) => s === synt) + 1];
  let nextText = nextFragment?.fragment ?? "";
  return nextText.length - nextText.trimStart().length;
}

function getGhostStyle(synt: SyntaxFragment): CSSProperties {
  let tl = Math.max(trailingLines(synt) - 1, 1);
  return {
    "height": tl * 27 + "px",
    "-webkit-line-clamp": tl,
    "-webkit-box-orient": "vertical",
    "display": "-webkit-box",
    "visibility": "visible",
    "position": "absolute",
    "top": "0px",
    "left": "0px",
  };
}

const syntax = computed(() => {
  if (!text.value) {
    return []; // Dan doesn't understand why this line is necessary, but w/e.
  }
  if (cached.value.text == text.value) {
    return cached.value.syntax;
  } else {
    cached.value = { text: text.value, syntax: parse(text.value, dataContext.value) };
    return cached.value.syntax;
  }
});

async function transcriptButtonClicked() {
  let status = showTranscript.value;
  let syntaxFragment = await applyVars(syntax.value, dataContext.value);
  cached.value = { text: text.value, syntax: syntaxFragment };
  transcriptButtonHasBeenClicked.value = !status;
}

const sideList = computed(() => {
  return varList.value.concat([
    {
      path: "@Assistant",
      data: "Get the assistant to respond, then continue the conversation.",
    },
    {
      path: "User:",
      data: "Speak as the user. (default)",
    },
    {
      path: "Assistant:",
      data: "Speak as the Jyranian.",
    },
    {
      path: "System:",
      data: "Speak as System. Gpt 3.5 doesn't use this well.",
    },
    {
      path: "@gpt-4",
      data: "Use gpt-4, the more powerful & slower model.",
    },
    {
      path: "@gpt-4-turbo",
      data: "Use gpt-4-turbo. It has an updated knowledge cutoff of April 2023 and introduces a 128k context window (the equivalent of 300 pages of text in a single prompt). The model is also 3X cheaper for input tokens and 2X cheaper for output tokens compared to the original GPT-4 model. The maximum number of output tokens for this model is 4096.",
    },
    {
      path: "@temp precise",
      data: "Always choose the most common word (default)",
    },
    {
      path: "@temp balanced",
      data: "Occasionally opt for something unusual.",
    },
    {
      path: "@temp creative",
      data: "Say something unusual as often as a human does.",
    },
    {
      path: "@temp super-creative",
      data: "Actively prefer unusual choices.",
    },
    {
      path: "@then Summarize.",
      data: "Do something (IE Summary) with the response.",
    },
  ]);
});

const activePhrase = computed(() => {
  if (!isMounted.value) {
    return "";
  }
  let textarea = textareaRef.value as HTMLTextAreaElement;
  let start = textarea.selectionStart || selectionStart.value;
  let before = text.value.substring(0, start).match(/[^\s]*$/)![0];
  let after = text.value.substring(start).match(/^[^\s]*/)![0];
  return before + after;
});

const activePhraseContainsVariable = computed(() => {
  return activePhrase.value.includes("$");
});

const filteredSideList = ref([...sideList.value]);

function updateFilteredSideList(): void {
  filteredSideList.value = getFilteredSideList();
}

function getFilteredSideList(): { path: string; data: string }[] {
  let currActivePhrase = activePhrase.value;
  let fullList = sideList.value;
  let list = fullList.filter((x) => x.path.startsWith(currActivePhrase));
  if (!list.length) {
    list = fullList;
    currActivePhrase = "";
  }
  list = list.filter(
    (x) =>
      !x.path.startsWith("$") ||
      !x.path.substring(Math.min(currActivePhrase.length + 1, x.path.length)).includes("."),
  );

  return list;
}

watch(activePhrase, () => {
  if (activePhraseContainsVariable.value || activePhrase.value.length === 0) {
    updateFilteredSideList();
  }
});

onMounted(async () => {
  let textarea = textareaRef.value as HTMLTextAreaElement;
  textarea.addEventListener("keydown", checkcaret); // Every character down
  textarea.addEventListener("keyup", checkcaret); // Every character up
  textarea.addEventListener("mousedown", checkcaret); // Click down
  textarea.addEventListener("mouseup", checkcaret); // Click down
  textarea.addEventListener("touchstart", checkcaret); // Mobile
  textarea.addEventListener("input", checkcaret); // Other input events
  textarea.addEventListener("paste", checkcaret); // Clipboard actions
  textarea.addEventListener("cut", checkcaret);
  textarea.addEventListener("mousemove", checkcaret); // Selection, dragging text
  textarea.addEventListener("select", checkcaret); // Some browsers support this event
  textarea.addEventListener("selectstart", checkcaret); // Some browsers support this event
  window.addEventListener("resize", resize);

  if (props.currentChat) {
    text.value = props.currentChat.text;
  }

  await getVariablesData();

  getVarList(dataContext.value).then((vl) => {
    varList.value = vl;
    varList.value.forEach((v) => getVar(v.path, dataContext.value).then((d) => (v.data = d)));
    updateFilteredSideList();
  });
  resize();
  isMounted.value = true;
});

const route = useRoute();

async function getVariablesData() {
  const subjectQuery = route.query.subject;
  const idQuery = route.query.id;

  if (subjectQuery && idQuery) {
    try {
      dataContext.value = await getDataContextWithSubject(
        subjectQuery as DataSubject,
        idQuery as string,
      );
    } catch (e: unknown) {
      const error = e as AxiosError;
      subjectError.value = error.response?.data ?? "Error getting subject";
      dataContext.value = getDataContext();
    }
  } else {
    dataContext.value = getDataContext();
  }
}

async function saveConversation() {
  if (text.value === "") {
    return;
  }

  saveError.value = null;
  const model = createEntryModel();
  const response = await saveEntry(model);

  if (!response.success) {
    saveError.value = response.error;
  }

  emit("update-history-item", model);
}

function createEntryModel() {
  const subjectQuery = route.query.subject;
  const idQuery = route.query.id as string;

  const subjectType = subjectQuery ? getTypeFromParam(subjectQuery as string) : undefined;

  const model: ScratchpadEntryApiModel = {
    authorId: ctx.user.id,
    pageId: props.currentChat.pageId,
    pageTitle: title.value,
    subjectUserId: subjectType === DataSubjects.USER ? idQuery : "",
    subjectTeamId: subjectType === DataSubjects.TEAM ? idQuery : undefined,
    subjectOrgId: subjectType === DataSubjects.ORG ? idQuery : undefined,
    text: text.value,
  };

  return model;
}

async function onTitleBlur() {
  // don't save if there's no text content, but update the UI so a user doesn't lose the title if they click on another entry
  if (text.value !== "") {
    await saveConversation();
  } else {
    const model = createEntryModel();
    emit("update-history-item", model);
  }
}

function keydown(event: KeyboardEvent) {
  let keys = ["Enter", ".", "?", "!"];
  //Right Ctrl
  if (event.key == "Enter" && event.ctrlKey) {
    go();
    event.preventDefault();
  } else if (event.key == "Enter" && event.altKey) {
    continueConversation();
    event.preventDefault();
  } else if (event.key == "Tab") {
    insertVar(filteredSideList.value[0]);
    event.preventDefault();
  }
}
const run = ref(0);
const assistantGhostTexts = ref<string[]>([]);
const assistantGhostTextsAreCompleted = ref<boolean[]>([]);

async function go() {
  run.value++;
  let newRun = run.value;
  let syntaxFragments = await applyVars(syntax.value, dataContext.value);
  cached.value = { text: text.value, syntax: syntaxFragments };
  await saveConversation();
  response.value = "...";

  const { processed: messages } = syntaxToApiCall(syntaxFragments);

  assistantGhostTexts.value = [];
  assistantGhostTextsAreCompleted.value = [];
  let i = 0;
  await chat(messages, (content, finished, extras) => {
    if (newRun === run.value) {
      assistantGhostTexts.value[i] = extras.currentStream.content;
      if (extras.currentStream.finished) {
        assistantGhostTextsAreCompleted.value[i] = true;
        i++;
        assistantGhostTexts.value[i] = "";
      }
      // current stream refers to the current message being processed; there may be multiple in a series of nexts.

      response.value = content;
    }
  });
}

function resize() {
  let textarea = textareaRef.value as HTMLTextAreaElement;
  setTimeout(() => {
    textarea.scroll(0, 0);
    let heightBefore = textarea.scrollHeight;
    textarea.style.height = Math.max(heightBefore - 10, 0) + "px";
    textarea.style.height = textarea.scrollHeight + "px";
    let heightAfter = textarea.scrollHeight;
    if (heightBefore != heightAfter) {
      setTimeout(() => resize(), 5);
    }
  }, 0);
}

watch(text, () => {
  let textarea = textareaRef.value as HTMLTextAreaElement;
  window["_jyreScratchpadText"] = text.value;
  resize();
});

watch(
  () => props.currentChat,
  () => {
    text.value = props.currentChat.text;
    title.value = props.currentChat?.pageTitle ?? "Untitled";
    response.value = "";
    assistantGhostTexts.value = [] as string[];
  },
);

const caretcheckActive = ref(false);
const selectionStart = ref(0);
const selectionEnd = ref(0);
const lastInsertion = ref(0);

function checkcaret(event?: Event) {
  let textarea = textareaRef.value as HTMLTextAreaElement;
  if (!caretcheckActive.value) {
    caretcheckActive.value = true;
    setTimeout(() => {
      caretcheckActive.value = false;
      selectionStart.value = textarea.selectionStart;
      selectionEnd.value = textarea.selectionEnd;
    }, 10);
  }
}

watch(text, () => {
  checkcaret();
});

function insertVar(v: { path: string; data: string }) {
  let path = v.path;
  let textarea = textareaRef.value as HTMLTextAreaElement;
  textarea.focus();
  if (path.startsWith("@model") || path.startsWith("@temp") || path.startsWith("@gpt-4")) {
    let lines = text.value.split("\n");

    if (path.startsWith("@model") || path.startsWith("@gpt-4")) {
      lines = lines.filter((l) => !l.startsWith("@model") && !l.startsWith("@gpt-4"));
    }

    if (path.startsWith("@temp")) {
      lines = lines.filter((l) => !l.startsWith("@temp"));
    }

    lines.splice(
      lines.concat("").findIndex((l) => !l.startsWith("@")),
      0,
      path,
    );
    text.value = lines.join("\n");
  } else {
    var startPos = textarea.selectionStart || selectionStart.value;
    var endPos = textarea.selectionEnd || selectionEnd.value;

    if (path.startsWith("@then")) {
      startPos = endPos = text.value.length;
    }

    if (
      path === "User:" ||
      path === "Assistant:" ||
      path === "System:" ||
      path.startsWith("@then") ||
      path.startsWith("@Assistant")
    ) {
      path = path + " ";
      if (text.value.length !== 0) {
        path = "\n" + path;
      }
    }

    let textBefore = text.value.substring(0, startPos);
    let textAfter = text.value.substring(endPos, text.value.length);
    let prefix = textBefore.split("$").pop()!;
    if (path.startsWith("$" + prefix) && prefix !== textBefore) {
      textBefore = textBefore.substring(0, textBefore.length - prefix.length - 1);
    } else if (textBefore && !/\s$/g.test(textBefore)) {
      textBefore = textBefore + " ";
    }
    text.value = textBefore + path + textAfter;

    lastInsertion.value = textBefore.length + path.length;
    nextTick(() => (textarea.selectionStart = textarea.selectionEnd = lastInsertion.value));
  }
}

function continueConversation() {
  let textarea = textareaRef.value as HTMLTextAreaElement;

  // don't add a new @Assistant if this.text ends with @Assistant
  if (!text.value.trimEnd().endsWith("@Assistant")) {
    text.value += "\n\n@Assistant\n\n";
  }
  response.value = "";
  nextTick(() => (textarea.selectionStart = textarea.selectionEnd = text.value.length));
}

async function handleInput() {
  if (inputTimeout.value !== null) {
    clearTimeout(inputTimeout.value);
  }

  inputTimeout.value = setTimeout(async () => {
    await saveConversation();
    inputTimeout.value = null;
  }, 1000) as any;
}

// @Component({})
// export default class ScratchPadPage extends Vue {
//   @Prop() currentChat!: ScratchpadEntryApiModel;

//   text = (window["_jyreScratchpadText"] as string) || "";
//   cached = { text: "", syntax: [] as SyntaxFragment[] };
//   transcriptButtonHasBeenClicked = false;

//   response = "";
//   subjectError: null | string = null;
//   saveError: null | string = null;
//   inputTimeout: null | number = null;
//   dataContext: ReturnType<typeof getDataContext> | null = null;
//   varList = [] as { path: string; data: string }[];
//   isMounted = false;
//   ctx = csContext;

//   title = this.currentChat?.pageTitle ?? "Untitled";

//   get showTranscript(): boolean {
//     return !!(
//       this.transcriptButtonHasBeenClicked &&
//       this.syntax &&
//       this.syntax[0] &&
//       (this.syntax[0].output || this.syntax[0].error)
//     );
//   }

//   async transcriptButtonClicked() {
//     let status = this.showTranscript;
//     let syntax = await applyVars(this.syntax, this.dataContext);
//     this.cached = { text: this.text, syntax: syntax };
//     this.transcriptButtonHasBeenClicked = !status;
//   }

//   truncateData(data: string) {
//     data = data || "";
//     if (this.filteredSideList.length === 1) {
//       return data;
//     }
//     let newData = data.split("\n").slice(0, 3).join("\n").slice(0, 100);
//     if (newData.length !== data.length && newData.trim()) {
//       newData = newData + "...";
//     }
//     return newData;
//   }

//   getGhostText(synt: SyntaxFragment) {
//     if (synt.directive?.name !== "Assistant") {
//       return undefined;
//     }

//     if (synt.directive.options.trim()) {
//       return "";
//     }

//     let whichAssistantCall = this.syntax
//       .filter((x) => x.directive?.name === "Assistant")
//       .findIndex((x) => x === synt);

//     let prefix = "                         ";
//     let text = this.assistantGhostTexts[whichAssistantCall];
//     if (text !== undefined && !this.assistantGhostTextsAreCompleted[whichAssistantCall]) {
//       prefix = prefix + "🖊️";
//     }
//     return prefix + (text ?? "".trim());
//   }

//   trailingLines(synt: SyntaxFragment) {
//     let nextFragment = this.syntax[this.syntax.findIndex((s) => s === synt) + 1];
//     let nextText = nextFragment?.fragment ?? "";
//     return nextText.length - nextText.trimStart().length;
//   }

//   getGhostStyle(synt: SyntaxFragment) {
//     let tl = Math.max(this.trailingLines(synt) - 1, 1);
//     return {
//       "height": tl * 27 + "px",
//       "-webkit-line-clamp": tl,
//       "-webkit-box-orient": "vertical",
//       "display": "-webkit-box",
//       "visibility": "visible",
//       "position": "absolute",
//       "top": "0px",
//       "left": "0px",
//     };
//   }

//   get syntax() {
//     if (!this.text) {
//       return []; // Dan doesn't understand why this line is necessary, but w/e.
//     }
//     if (this.cached.text == this.text) {
//       return this.cached.syntax;
//     } else {
//       this.cached = { text: this.text, syntax: parse(this.text, this.dataContext) };
//       return this.cached.syntax;
//     }
//   }

//   get sideList(): { path: string; data: string }[] {
//     return this.varList.concat([
//       {
//         path: "@Assistant",
//         data: "Get the assistant to respond, then continue the conversation.",
//       },
//       {
//         path: "User:",
//         data: "Speak as the user. (default)",
//       },
//       {
//         path: "Assistant:",
//         data: "Speak as the Jyranian.",
//       },
//       {
//         path: "System:",
//         data: "Speak as System. Gpt 3.5 doesn't use this well.",
//       },
//       {
//         path: "@gpt-4",
//         data: "Use gpt-4, the more powerful & slower model.",
//       },
//       {
//         path: "@gpt-4-turbo",
//         data: "Use gpt-4-turbo. It has an updated knowledge cutoff of April 2023 and introduces a 128k context window (the equivalent of 300 pages of text in a single prompt). The model is also 3X cheaper for input tokens and 2X cheaper for output tokens compared to the original GPT-4 model. The maximum number of output tokens for this model is 4096.",
//       },
//       {
//         path: "@temp precise",
//         data: "Always choose the most common word (default)",
//       },
//       {
//         path: "@temp balanced",
//         data: "Occasionally opt for something unusual.",
//       },
//       {
//         path: "@temp creative",
//         data: "Say something unusual as often as a human does.",
//       },
//       {
//         path: "@temp super-creative",
//         data: "Actively prefer unusual choices.",
//       },
//       {
//         path: "@then Summarize.",
//         data: "Do something (IE Summary) with the response.",
//       },
//     ]);
//   }

//   get activePhrase() {
//     if (!this.isMounted) {
//       return "";
//     }
//     let textarea = this.$refs.textarea as HTMLTextAreaElement;
//     let start = textarea.selectionStart || this.selectionStart;
//     let before = this.text.substring(0, start).match(/[^\s]*$/)![0];
//     let after = this.text.substring(start).match(/^[^\s]*/)![0];
//     return before + after;
//   }

//   get activePhraseContainsVariable() {
//     return this.activePhrase.includes("$");
//   }

//   filteredSideList = [...this.sideList];

//   updateFilteredSideList(): void {
//     this.filteredSideList = this.getFilteredSideList();
//   }

//   getFilteredSideList(): { path: string; data: string }[] {
//     let activePhrase = this.activePhrase;
//     let fullList = this.sideList;
//     let list = fullList.filter((x) => x.path.startsWith(activePhrase));
//     if (!list.length) {
//       list = fullList;
//       activePhrase = "";
//     }
//     list = list.filter(
//       (x) =>
//         !x.path.startsWith("$") ||
//         !x.path.substring(Math.min(activePhrase.length + 1, x.path.length)).includes("."),
//     );

//     return list;
//   }

//   @Watch("activePhrase")
//   updateSideList() {
//     if (this.activePhraseContainsVariable || this.activePhrase.length === 0) {
//       this.updateFilteredSideList();
//     }
//   }

//   async mounted() {
//     let textarea = this.$refs.textarea as HTMLTextAreaElement;
//     textarea.addEventListener("keydown", this.checkcaret); // Every character down
//     textarea.addEventListener("keyup", this.checkcaret); // Every character up
//     textarea.addEventListener("mousedown", this.checkcaret); // Click down
//     textarea.addEventListener("mouseup", this.checkcaret); // Click down
//     textarea.addEventListener("touchstart", this.checkcaret); // Mobile
//     textarea.addEventListener("input", this.checkcaret); // Other input events
//     textarea.addEventListener("paste", this.checkcaret); // Clipboard actions
//     textarea.addEventListener("cut", this.checkcaret);
//     textarea.addEventListener("mousemove", this.checkcaret); // Selection, dragging text
//     textarea.addEventListener("select", this.checkcaret); // Some browsers support this event
//     textarea.addEventListener("selectstart", this.checkcaret); // Some browsers support this event
//     window.addEventListener("resize", this.resize);

//     if (this.currentChat) {
//       this.text = this.currentChat.text;
//     }

//     await this.getVariablesData();

//     getVarList(this.dataContext).then((vl) => {
//       this.varList = vl;
//       this.varList.forEach((v) => getVar(v.path, this.dataContext).then((d) => (v.data = d)));
//       this.updateFilteredSideList();
//     });
//     this.resize();
//     this.isMounted = true;
//   }

//   async getVariablesData() {
//     const subjectQuery = this.$route.query.subject;
//     const idQuery = this.$route.query.id;

//     if (subjectQuery && idQuery) {
//       try {
//         this.dataContext = await getDataContextWithSubject(
//           subjectQuery as DataSubject,
//           idQuery as string,
//         );
//       } catch (e: unknown) {
//         const error = e as AxiosError;
//         this.subjectError = error.response?.data ?? "Error getting subject";
//         this.dataContext = getDataContext();
//       }
//     } else {
//       this.dataContext = getDataContext();
//     }
//   }

//   keydown(event: KeyboardEvent) {
//     let keys = ["Enter", ".", "?", "!"];
//     //Right Ctrl
//     if (event.key == "Enter" && event.ctrlKey) {
//       this.go();
//       event.preventDefault();
//     } else if (event.key == "Enter" && event.altKey) {
//       this.continueConversation();
//       event.preventDefault();
//     } else if (event.key == "Tab") {
//       this.insertVar(this.filteredSideList[0]);
//       event.preventDefault();
//     }
//   }

//   run = 0;
//   assistantGhostTexts = [] as string[];
//   assistantGhostTextsAreCompleted = [] as boolean[];

//   async go() {
//     this.run++;
//     let run = this.run;
//     let syntax = await applyVars(this.syntax, this.dataContext);
//     this.cached = { text: this.text, syntax: syntax };
//     await this.saveConversation();
//     this.response = "...";

//     const { processed: messages } = syntaxToApiCall(syntax);

//     this.assistantGhostTexts = [];
//     this.assistantGhostTextsAreCompleted = [];
//     let i = 0;
//     await chat(messages, (content, finished, extras) => {
//       if (run === this.run) {
//         Vue.set(this.assistantGhostTexts, i, extras.currentStream.content);
//         if (extras.currentStream.finished) {
//           Vue.set(this.assistantGhostTextsAreCompleted, i, true);
//           i++;
//           Vue.set(this.assistantGhostTexts, i, "");
//         }
//         // current stream refers to the current message being processed; there may be multiple in a series of nexts.

//         this.response = content;
//       }
//     });
//   }

//   resize() {
//     let textarea = this.$refs.textarea as HTMLTextAreaElement;
//     setTimeout(() => {
//       textarea.scroll(0, 0);
//       let heightBefore = textarea.scrollHeight;
//       textarea.style.height = Math.max(heightBefore - 10, 0) + "px";
//       textarea.style.height = textarea.scrollHeight + "px";
//       let heightAfter = textarea.scrollHeight;
//       if (heightBefore != heightAfter) {
//         setTimeout(() => this.resize(), 5);
//       }
//     }, 0);
//   }

//   @Watch("text")
//   changed() {
//     let textarea = this.$refs.textarea as HTMLTextAreaElement;
//     window["_jyreScratchpadText"] = this.text;
//     this.resize();
//   }

//   @Watch("currentChat")
//   update() {
//     this.text = this.currentChat.text;
//     this.title = this.currentChat?.pageTitle ?? "Untitled";
//     this.response = "";
//     this.assistantGhostTexts = [] as string[];
//   }

//   caretcheckActive = false;

//   @Watch("text")
//   checkcaret(event: Event) {
//     let textarea = this.$refs.textarea as HTMLTextAreaElement;
//     if (!this.caretcheckActive) {
//       this.caretcheckActive = true;
//       setTimeout(() => {
//         this.caretcheckActive = false;
//         this.selectionStart = textarea.selectionStart;
//         this.selectionEnd = textarea.selectionEnd;
//       }, 10);
//     }
//   }

//   selectionStart = 0;
//   selectionEnd = 0;
//   lastInsertion = 0;

//   insertVar(v: { path: string; data: string }) {
//     let path = v.path;
//     let textarea = this.$refs.textarea as HTMLTextAreaElement;
//     textarea.focus();
//     if (path.startsWith("@model") || path.startsWith("@temp") || path.startsWith("@gpt-4")) {
//       let lines = this.text.split("\n");

//       if (path.startsWith("@model") || path.startsWith("@gpt-4")) {
//         lines = lines.filter((l) => !l.startsWith("@model") && !l.startsWith("@gpt-4"));
//       }

//       if (path.startsWith("@temp")) {
//         lines = lines.filter((l) => !l.startsWith("@temp"));
//       }

//       lines.splice(
//         lines.concat("").findIndex((l) => !l.startsWith("@")),
//         0,
//         path,
//       );
//       this.text = lines.join("\n");
//     } else {
//       var startPos = textarea.selectionStart || this.selectionStart;
//       var endPos = textarea.selectionEnd || this.selectionEnd;

//       if (path.startsWith("@then")) {
//         startPos = endPos = this.text.length;
//       }

//       if (
//         path === "User:" ||
//         path === "Assistant:" ||
//         path === "System:" ||
//         path.startsWith("@then") ||
//         path.startsWith("@Assistant")
//       ) {
//         path = path + " ";
//         if (this.text.length !== 0) {
//           path = "\n" + path;
//         }
//       }

//       let textBefore = this.text.substring(0, startPos);
//       let textAfter = this.text.substring(endPos, this.text.length);
//       let prefix = textBefore.split("$").pop()!;
//       if (path.startsWith("$" + prefix) && prefix !== textBefore) {
//         textBefore = textBefore.substring(0, textBefore.length - prefix.length - 1);
//       } else if (textBefore && !/\s$/g.test(textBefore)) {
//         textBefore = textBefore + " ";
//       }
//       this.text = textBefore + path + textAfter;

//       this.lastInsertion = textBefore.length + path.length;
//       Vue.nextTick(() => (textarea.selectionStart = textarea.selectionEnd = this.lastInsertion));
//     }
//   }

//   continueConversation() {
//     let textarea = this.$refs.textarea as HTMLTextAreaElement;

//     // don't add a new @Assistant if this.text ends with @Assistant
//     if (!this.text.trimEnd().endsWith("@Assistant")) {
//       this.text += "\n\n@Assistant\n\n";
//     }
//     this.response = "";
//     Vue.nextTick(() => (textarea.selectionStart = textarea.selectionEnd = this.text.length));
//   }

//   async onTitleBlur() {
//     // don't save if there's no text content, but update the UI so a user doesn't lose the title if they click on another entry
//     if (this.text !== "") {
//       await this.saveConversation();
//     } else {
//       const model = this.createEntryModel();
//       this.$emit("update-history-item", model);
//     }
//   }

//   createEntryModel() {
//     const subjectQuery = this.$route.query.subject;
//     const idQuery = this.$route.query.id as string;

//     const subjectType = subjectQuery ? getTypeFromParam(subjectQuery as string) : undefined;

//     const model: ScratchpadEntryApiModel = {
//       authorId: this.ctx.user.id,
//       pageId: this.currentChat.pageId,
//       pageTitle: this.title,
//       subjectUserId: subjectType === DataSubjects.USER ? idQuery : "",
//       subjectTeamId: subjectType === DataSubjects.TEAM ? idQuery : undefined,
//       subjectOrgId: subjectType === DataSubjects.ORG ? idQuery : undefined,
//       text: this.text,
//     };

//     return model;
//   }

//   // we want this to save on every keystroke, but throttle it
//   async saveConversation() {
//     if (this.text === "") {
//       return;
//     }

//     this.saveError = null;
//     const model = this.createEntryModel();
//     const response = await saveEntry(model);

//     if (!response.success) {
//       this.saveError = response.error;
//     }

//     this.$emit("update-history-item", model);
//   }

//   async handleInput() {
//     if (this.inputTimeout !== null) {
//       clearTimeout(this.inputTimeout);
//     }

//     this.inputTimeout = setTimeout(async () => {
//       await this.saveConversation();
//       this.inputTimeout = null;
//     }, 1000) as any;
//   }
// }

return (_ctx: any,_cache: any) => {
  const _directive_markdown = _resolveDirective("markdown")!

  return (_openBlock(), _createElementBlock("div", {
    onKeydown: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (keydown($event)), ["stop"])),
    class: "smart-scratchpad text-big flex-1",
    style: {"margin":"30px 10px 0"}
  }, [
    _createElementVNode("div", null, [
      (subjectError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(subjectError.value), 1))
        : _createCommentVNode("", true),
      (saveError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(saveError.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("header", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "page-title",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
            class: "text-input",
            onBlur: onTitleBlur,
            "data-test": "scratchpad-title-input"
          }, null, 544), [
            [_vModelText, title.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(syntax.value, (synt, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                class: _normalizeClass({
                'scratchpad-variable': synt.variable,
                'scratchpad-error': synt.error,
                'scratchpad-assistant': synt.isMessageBreak && synt.role === 'assistant',
                'scratchpad-user': synt.isMessageBreak && synt.role === 'user',
                'scratchpad-system': synt.isMessageBreak && synt.role === 'system',
                'scratchpad-directive': synt.directive,
                'scratchpad-assistant-directive':
                  synt.directive && synt.directive.name === 'Assistant',
              })
              }, [
                _createTextVNode(_toDisplayString(synt.fragment), 1),
                (synt.directive && synt.directive.name === 'Assistant')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "scratchpad-ghost-text",
                      style: _normalizeStyle(getGhostStyle(synt)),
                      "data-test": "scratchpad-ghost-text"
                    }, _toDisplayString(getGhostText(synt)), 5))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]),
          _withDirectives(_createElementVNode("textarea", {
            ref_key: "textareaRef",
            ref: textareaRef,
            class: "scratchpad-textarea",
            style: {"height":"27px"},
            rows: "2000",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((text).value = $event)),
            onInput: handleInput,
            onFocus: _cache[2] || (_cache[2] = ($event: any) => (selectionStart.value = 0)),
            "data-test": "smart-scratchpad",
            "aria-label": "prompt input"
          }, null, 544), [
            [_vModelText, text.value]
          ])
        ]),
        _createElementVNode("div", { style: {"position":"relative","float":"left","z-index":"22"} }, [
          _createElementVNode("button", {
            onClick: transcriptButtonClicked,
            style: {"width":"80px"},
            class: "btn btn-default",
            "data-test": "vars-button",
            type: "button"
          }, _hoisted_9)
        ]),
        _createElementVNode("div", { style: {"position":"relative","float":"right","z-index":"22"} }, [
          _hoisted_10,
          _createElementVNode("button", {
            onClick: go,
            style: {"width":"80px"},
            class: "btn btn-primary",
            type: "button",
            "data-test": "scratchpad-chat-button"
          }, _hoisted_12)
        ]),
        _hoisted_13,
        _hoisted_14,
        ((response.value || '').trim() || showTranscript.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (showTranscript.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(syntax.value, (synt, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (!synt.directive)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: index,
                                class: _normalizeClass({
                    'scratchpad-variable': synt.variable,
                    'scratchpad-error': synt.error,
                    'scratchpad-assistant': synt.isMessageBreak && synt.role === 'assistant',
                    'scratchpad-user': synt.isMessageBreak && synt.role === 'user',
                    'scratchpad-system': synt.isMessageBreak && synt.role === 'system',
                    'scratchpad-directive': synt.directive,
                  }),
                                "data-test": synt.variable ? 'scratchpad-output' : ''
                              }, _toDisplayString(synt.error || synt.output), 11, _hoisted_18))
                            : (synt.directive.name === 'Assistant')
                              ? (_openBlock(), _createElementBlock("span", { key: index }, [
                                  _hoisted_19,
                                  _withDirectives(_createElementVNode("span", null, null, 512), [
                                    [_directive_markdown, ` ${(getGhostText(synt) || '').trim()}`]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                        ], 64))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true),
                ((response.value || '').trim() && showTranscript.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
                  : _createCommentVNode("", true),
                ((response.value || '').trim())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _withDirectives(_createElementVNode("span", _hoisted_26, null, 512), [
                        [_directive_markdown, response.value]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", { style: {"position":"relative","float":"right","z-index":"22"} }, [
                _hoisted_27,
                _createElementVNode("button", {
                  onClick: continueConversation,
                  class: "btn btn-default",
                  style: {"position":"relative","float":"right","width":"80px"},
                  "data-test": "scratchpad-continue-button",
                  type: "button"
                }, _hoisted_29)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_30, [
        (!varList.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Loading data..."))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSideList.value, (v) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"margin-bottom":"20px"},
            key: v.path
          }, [
            _createElementVNode("a", {
              href: "javascript:void(0)",
              onClick: ($event: any) => (insertVar(v))
            }, _toDisplayString(v.path), 9, _hoisted_32),
            ((v.data || '').trim())
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(truncateData(v.data)), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ], 32))
}
}

})